import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { Utilities, Services, AppUtils } from '@gscope-mfe/app-bridge';
import Loader from '../Loader';
import classes from './LanguageSelector.module.css';
import { useTranslation } from 'react-i18next';
const { FormControl, FormControlLabel, Radio, Button, RadioGroup } = MaterialUiCore;
const { setUserPreference } = Utilities;

const LanguageSelector = ({ LeftPanelShowToggle, langPref, supportedlngs }) => {
    const { allLangs, setPrefLang } = AppUtils.get();
    const [currentLang, setCurrentLang] = React.useState('');
    const [langChosen, setLangChosen] = React.useState('en');
    const [isLoading, setIsLoading] = React.useState(false);
    const { t, i18n } = useTranslation('commonLang');
    const appPref = 'appPreferences';

    React.useEffect(() => {
        if (langPref && langPref.current) {
            setLangChosen(langPref.current);
        }
    }, [langPref]);

    const changeLanguage = () => {
        if (langChosen !== currentLang) {
            setIsLoading(true);
            i18n.changeLanguage(langChosen)
                .then((t) => {
                    setPrefLang && setPrefLang({ previous: currentLang, current: langChosen });
                    setIsLoading(false);
                    setCurrentLang(langChosen);
                })
                .catch(() => {
                    setIsLoading(false);
                });
            const reqPayload = {
                pageName: appPref,
                key: 'prefLang',
                value: { lang: langChosen },
            };
            LeftPanelShowToggle();
            setUserPreference(reqPayload);
        }
    };
    const acceptChange = (event) => {
        setLangChosen(event.target.value);
    };
    return (
        <div style={{ height: '100%' }}>
            {allLangs && allLangs.length > 0 && (
                <FormControl variant="outlined" style={{ width: '100%', height: 'inherit' }} id="marketSelector">
                    <Loader show={isLoading} />
                    <RadioGroup
                        aria-label="language"
                        name="radio-buttons-group"
                        onChange={acceptChange}
                        className={classes.radioGroup}
                        data-testid="languages-list"
                        value={langChosen}
                    >
                        {allLangs.map((lang) => (
                            <FormControlLabel
                                className={classes.formControlLabel}
                                label={supportedlngs[lang] ? supportedlngs[lang] : lang.toLowerCase()}
                                key={lang}
                                value={lang}
                                control={<Radio />}
                            />
                        ))}
                    </RadioGroup>

                    <div className={classes.languageButton}>
                        <Button onClick={LeftPanelShowToggle}>{t('cancel')}</Button>
                        <Button
                            style={{ background: '#0071dc', color: 'white', borderRadius: '5px' }}
                            variant="contained"
                            onClick={changeLanguage}
                        >
                            {t('apply')}
                        </Button>
                    </div>
                </FormControl>
            )}
        </div>
    );
};

export default LanguageSelector;
